export default __webpack_public_path__ + "static/media/nectar-cares-logo-blue.66ed9289.svg";